module.exports = __webpack_public_path__ + "static/img/bigUserHeader.fda3837.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-dashboard/assets/bigUserHeader.png
// module id = kSZp
// module chunks = 95